import React from 'react';
import { Quote } from 'lucide-react';

/**
 * TestimonialsSection — ready for three genuine practitioner quotes.
 *
 * Usage:
 *   <TestimonialsSection testimonials={[
 *     { quote: "...", name: "Jane D.", specialism: "Massage Therapist", location: "Clapham" },
 *     { quote: "...", name: "Sam R.", specialism: "Aesthetics", location: "Clapham" },
 *     { quote: "...", name: "Alex P.", specialism: "Talking Therapist", location: "Clapham" },
 *   ]} />
 *
 * The section renders nothing when no testimonials are provided.
 * Do not add fictional quotes, names, businesses or photographs.
 */
export default function TestimonialsSection({ testimonials }) {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section className="py-16 sm:py-24 bg-white" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <h2 className="font-heading text-2xl sm:text-3xl font-medium text-[#1A1A1A] tracking-tight mb-10 text-center">
          From practitioners in our studios
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {testimonials.slice(0, 3).map((t, i) => (
            <div key={i} className="bg-[#FAF9F6] rounded-2xl p-6 sm:p-8 flex flex-col" data-testid={`testimonial-${i}`}>
              <Quote className="w-5 h-5 text-[#D8DBD3] mb-4 shrink-0" strokeWidth={1.5} />
              <p className="text-sm text-[#5C5C55] leading-relaxed flex-1 mb-5">
                {t.quote}
              </p>
              <div className="border-t border-[#E5E2DC] pt-4">
                <p className="text-sm font-medium text-[#1A1A1A]">{t.name}</p>
                {t.specialism && <p className="text-xs text-[#8A8B85] mt-0.5">{t.specialism}</p>}
                {t.location && <p className="text-xs text-[#8A8B85]">{t.location}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
